import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_option_field = _resolveComponent("option-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "show-action-close": true,
    "is-visible": $options.isVisible,
    title: $options.modalTitle,
    onActionClose: $options.close,
    onOpen: $options.onOpen
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link _ttl _tc--lighter",
        onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, _toDisplayString(_ctx.Resources.Layout.ModalCancelButton), 1 /* TEXT */),
      _createVNode(_component_base_button, {
        disabled: !_ctx.languageCandidate,
        size: "default",
        width: "compact",
        "text-transform": "none",
        bold: true,
        theme: "accent",
        onClick: _withModifiers($options.onLanguageSet, ["prevent"]),
        "data-qa": "modal-button:Save"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.Resources.Layout.ModalSaveButton), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_base_notificator, { "can-close": false }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.info), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_option_field, {
        modelValue: $options.selectedLanguage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.selectedLanguage) = $event)),
        "display-name": $options.label,
        options: _ctx.supportedLanguages,
        layout: "condensed",
        description: $options.description,
        "data-qa": "project-language-selector:PlatformLanguage"
      }, null, 8 /* PROPS */, ["modelValue", "display-name", "options", "description"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "title", "onActionClose", "onOpen"]))
}